import { render, staticRenderFns } from "./SaveData.vue?vue&type=template&id=5c8fef01&"
import script from "./SaveData.vue?vue&type=script&lang=js&"
export * from "./SaveData.vue?vue&type=script&lang=js&"
import style0 from "./SaveData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports